import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "icon", "label"]
  static values = { userId: Number, username: String, state: String }

  connect() {
    this.modal = null
    this.updateButton()
  }

  updateButton() {
    if (this.stateValue === "following") {
      this.iconTarget.className = "bi bi-person-check me-1"
      this.labelTarget.textContent = "Following"
      this.buttonTarget.className = "btn btn-success btn-sm"
    } else if (this.stateValue === "pending") {
      this.iconTarget.className = "bi bi-hourglass me-1"
      this.labelTarget.textContent = "Pending"
      this.buttonTarget.className = "btn btn-secondary btn-sm"
    } else {
      this.iconTarget.className = "bi bi-person-plus me-1"
      this.labelTarget.textContent = "Follow"
      this.buttonTarget.className = "btn btn-primary btn-sm"
    }
  }

  showModal() {
    const title = document.getElementById("followModalTitle")
    const body = document.getElementById("followModalBody")
    const confirmBtn = document.getElementById("followConfirmBtn")

    if (this.stateValue === "following") {
      title.textContent = "Unfollow"
      body.textContent = `Unfollow ${this.usernameValue}?`
      confirmBtn.innerHTML = '<i class="bi bi-person-dash me-1"></i>Unfollow'
      confirmBtn.className = "btn btn-danger btn-sm"
    } else if (this.stateValue === "pending") {
      title.textContent = "Cancel Request"
      body.textContent = `Cancel your follow request to ${this.usernameValue}?`
      confirmBtn.innerHTML = '<i class="bi bi-x-circle me-1"></i>Cancel Request'
      confirmBtn.className = "btn btn-secondary btn-sm"
    } else {
      title.textContent = "Follow"
      body.textContent = `Follow ${this.usernameValue}?`
      confirmBtn.innerHTML = '<i class="bi bi-person-plus me-1"></i>Follow'
      confirmBtn.className = "btn btn-primary btn-sm"
    }

    confirmBtn.onclick = () => this.toggleFollow()

    this.modal = new bootstrap.Modal(document.getElementById("followModal"))
    this.modal.show()
  }

  toggleFollow() {
    const csrfToken = document.querySelector("[name='csrf-token']").content

    fetch(`/social/toggle/${this.userIdValue}`, {
      method: "POST",
      headers: { "X-CSRF-Token": csrfToken }
    })
      .then(response => response.json())
      .then(data => {
        if (data.pending) {
          this.stateValue = "pending"
        } else if (data.following) {
          this.stateValue = "following"
        } else {
          this.stateValue = "not_following"
        }

        this.updateButton()

        if (this.modal) {
          this.modal.hide()
          this.modal = null
        }
      })
  }
}
